import Http from './../http';

const prefix = '/item';

export const getItems = website_id => {
  return Http.authApi().get(`${prefix}/${website_id}`);
};

export const storeItems = (items, page_id) =>
  Http.authApi().post(`${prefix}/store`, { items, page_id });



// WEBPACK FOOTER //
// ./src/js/services/editor/item.js